import { useCallback } from 'react'

import { customerioTracker } from 'lib'

import type { TZaiPrePromptLinkModel } from './zai-pre-prompt-link.types'

export const useZaiPrePromptLinkModel: TZaiPrePromptLinkModel = () => {
  const handleClick = useCallback(() => {
    customerioTracker.track(customerioTracker.eventNames.FEATURE_USED, {
      feature: 'zai',
      action: 'click_suggestion',
    })
  }, [])

  return {
    handleClick,
  }
}
